import { RestClient } from '@/api/rest-client'
import { PrintableDocument } from '@/api/model/printable-document'
import { BaseModel } from '@/api/base-model'

export class PrintableDocumentClient extends RestClient<PrintableDocument> {
    collectionName = 'printable_documents'
    parseData = PrintableDocument.fromData

    async create(data: any): Promise<PrintableDocument> {
        const formData = new FormData()

        for (const [key, value] of Object.entries<any>(data)) {
            if (value === undefined || key === 'collectionName') {
                continue
            }

            formData.append(key, value instanceof BaseModel ? value.resourceIdentifier : value)
        }

        try {
            await this.client.post(`${this.basePath}/printable_documents`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })

            return await this.get(data.id, true)
        } catch (error) {
            this.handleError(error)
        }
    }

    async createWithFile(data: any, file: File): Promise<PrintableDocument> {
        data.file = file

        return await this.create(data)
    }

    async update(id: string, data: any): Promise<PrintableDocument> {
        const formData = new FormData()

        for (const [key, value] of Object.entries<any>(data)) {
            if (value === undefined || key === 'collectionName') {
                continue
            }

            formData.append(key, value instanceof BaseModel ? value.resourceIdentifier : value)
        }

        try {
            await this.client.post(`${this.basePath}/printable_documents/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })

            return await this.get(data.id, true)
        } catch (error) {
            this.handleError(error)
        }
    }

    async updateWithFile(id: string, data: any, file: File): Promise<PrintableDocument> {
        data.file = file

        return await this.update(id, data)
    }
}
